// @ts-strict-ignore
import { RudderAnalytics } from "@rudderstack/analytics-js";
import { useEffect, useState } from "react";

import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";

const useRudderStackAnalytics = (enabled: boolean): RudderAnalytics | undefined => {
  const [analytics, setAnalytics] = useState<RudderAnalytics>();
  const { rudderstackDataPlaneUrl, rudderstackJsApiWriteKey } = useSharedGlobalConfig();

  useEffect(() => {
    if (!enabled || analytics) {
      return;
    }
    const analyticsInstance = new RudderAnalytics();
    analyticsInstance.load(rudderstackJsApiWriteKey, rudderstackDataPlaneUrl);

    window.rudderanalytics = analyticsInstance;
    setAnalytics(analyticsInstance);
  }, [analytics]);

  return analytics;
};

export { useRudderStackAnalytics };
